import { Container, Grid, Typography, Button } from "@mui/material";
import React from "react";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => {
  return {
    typoText: {
      color: "#000",
      fontFamily: "Rubik",
      fontWeight: 300,
      //   fontSize: 18,
    },
    typoHeadline: {
      color: "#000",
      fontFamily: "Rubik",
      fontWeight: 700,
      //   fontSize: 60,
    },
    textButton: {
      color: "#FFFFFF",
      fontFamily: "Rubik",
      fontWeight: 300,
      backgroundColor: "#001899",
      marginTop: 10,
      "&:hover": {
        backgroundColor: "#B3BCED",
        color: "#000",
        boxShadow: "2px 2px 8px 3px #E8ECFF",
      },
      boxShadow: "2px 2px 8px 3px #E8ECFF",
      //   fontSize: 18,
    },
  };
});

const Section1 = () => {
  const classes = useStyles();

  return (
    <>
      <Container id="home">
        <Grid container spacing={{ xs: 0, md: 5 }} alignItems="center">
          <Grid item xs={12} md={6} sx={{ paddingTop: 5 }}>
            <Typography className={classes.typoText} variant="h6">
              Hi, I am Musab Shaikh
            </Typography>
            <Typography className={classes.typoHeadline} variant="h2">
              Web Developer and <br /> UX Designer
            </Typography>
            <Typography className={classes.typoText} variant="h6">
              Self taught individual who gives attention to detail on every
              aspect of design which creates a user-friendly environment.I can
              also be very technical if needed
            </Typography>
            <Button
              variant="contained"
              className={classes.textButton}
              onClick={() =>
                window.open(
                  "https://drive.google.com/file/d/1kgGBL3NqdNiw01tMdAQykELsdmQ_AllT/view?usp=share_link"
                )
              }
            >
              My Resume
            </Button>
          </Grid>
          <Grid item xs={12} md={6}>
            <img src="pic1.png" width="100%" height="100%" />
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default Section1;
